const LOOKER_ACTIONS = {
    PROBE_DETAIL_VISITING_EVENT: 'PROBE_DETAIL_VISITING_EVENT',
    PM_GRAPH_ZOOM_EVENT: 'PM_GRAPH_ZOOM_EVENT',
    PM_GRAPH_RESET_ZOOM_EVENT: 'PM_GRAPH_RESET_ZOOM_EVENT',
    PROGRESS_GOAL_SET_EVENT: 'PROGRESS_GOAL_SET_EVENT',
    LEXILE_EVENT: 'LEXILE_EVENT',
    PERCENTILE_EVENT: 'PERCENTILE_EVENT',
    TRO: {
        AUDIO_PLAYER_EVENT: 'AUDIO_PLAYER_EVENT',
        BOOK_RESCORING_EVENT: 'BOOK_RESCORING_EVENT',
        REVERT_EVENT: 'REVERT_EVENT',
        RESCORED_WITH_THIRD_BOOK_EVENT: 'RESCORED_WITH_THIRD_BOOK_EVENT',
        RESCORED_NOT_SCORED_BOOK_EVENT: 'RESCORED_NOT_SCORED_BOOK_EVENT',
    },
    SELECT_INDIVIDUAL_STUDENT: 'SELECT_INDIVIDUAL_STUDENT',
    DOWNLOAD_STUDENT_ACTIVITY: 'DOWNLOAD_STUDENT_ACTIVITY',
    SORT_STUDENTS_BY_NAME: 'SORT_STUDENTS_BY_NAME',
    SEE_ACTIVITIES: 'SEE_ACTIVITIES',
    HELP_DETAILS: 'HELP_DETAILS',
    DOWNLOAD_ALL_ACTIVITIES: 'DOWNLOAD_ALL_ACTIVITIES',
    OBSERVATION_SELECT: 'OBSERVATION_SELECT',
    SELECT_PAGE: 'SELECT_PAGE',
    SELECT_SKILL: 'SELECT_SKILL',
    DOWNLOAD_ACTIVITY: 'DOWNLOAD_ACTIVITY',
    SWITCH_INSTRUCTION_TAB: 'SWITCH_INSTRUCTION_TAB',
    SELECT_HELP_ITEM: 'SELECT_HELP_ITEM',
    PRINT_CURRENT_PAGE: 'PRINT_CURRENT_PAGE',
    DOWNLOAD_PDF_LANGUAGE_CONSIDERATION: 'DOWNLOAD_PDF_LANGUAGE_CONSIDERATION',
    SWITCH_PROGRESS_TAB: 'SWITCH_PROGRESS_TAB',
    SWITCH_LANGUAGE_CONSIDERATIONS_TAB: 'SWITCH_LANGUAGE_CONSIDERATIONS_TAB',
    SELECTED_HEADER_DROPDOWN: 'SELECTED_HEADER_DROPDOWN',
    SWITCH_PM_PERIOD: 'SWITCH_PM_PERIOD',
    SWITCH_GROWTH_ANALYSIS_PERIOD: 'SWITCH_GROWTH_ANALYSIS_PERIOD',
};

export default LOOKER_ACTIONS;
